import { render, staticRenderFns } from "./EditHowItWorks.vue?vue&type=template&id=545ca595&scoped=true&"
import script from "./EditHowItWorks.vue?vue&type=script&lang=js&"
export * from "./EditHowItWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545ca595",
  null
  
)

export default component.exports